export default "__VITE_ASSET__6RXAzX6A__"